import React from 'react';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { MarketTicker } from '../components/MarketTicker';
import { MarketStrip } from '../components/MarketStrip';
import { HeroSection } from '../components/HeroSection';
import { BottomArticles } from '../components/BottomArticles';
import { AdPlaceholder } from '../components/AdPlaceholder';
export function Home2() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-426" data-mp="1kwtlwghz0msq">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-427" data-mp="1pu1zs4w364o6">
        <Header data-id="element-428" data-mp="1ps8y740byan1" />
        <Navigation data-id="element-429" data-mp="1uty4y7gis25b" />

        {/* Top Banner Ad — above ticker in this variant */}
        <div className="py-4 md:py-6 flex justify-center" data-id="element-430" data-mp="1zkejxvzznvts">
          <AdPlaceholder width="w-full max-w-[728px]" height="h-[50px] md:h-[90px]" text="Wenda Ingredients Advertisement" data-id="element-431" data-mp="1zlzehlmazern" />
        </div>
      </div>

      {/* Full-width ticker bar — below the ad banner */}
      <MarketTicker data-id="element-432" data-mp="1yrp66ywhezen" />

      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-433" data-mp="1yqxazp6sr3ow">
        <div className="pt-6" data-id="element-434" data-mp="1tt5lt2xjdvoe" />
        <main data-id="element-435" data-mp="1ttx6hipli8zw">
          <HeroSection data-id="element-436" data-mp="1ttfe4x620ex9" />
          <BottomArticles data-id="element-437" data-mp="1tuyraewey9ut" />
          <MarketStrip data-id="element-438" data-mp="1p1x8hvt35q5y" />
        </main>

        {/* Bottom Banner Ad */}
        <div className="py-8 border-t border-gray-200 flex justify-center" data-id="element-439" data-mp="1ozswsroy3mv4">
          <AdPlaceholder width="w-full max-w-[970px]" height="h-[50px] md:h-[90px]" text="Intralox Advertisement" data-id="element-440" data-mp="1l0bqxx5lwnpf" />
        </div>
      </div>
    </div>;
}